import React, { useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box, Image, Text, AspectRatio, Flex } from "@chakra-ui/react";
import * as PostAdditionalTypes from "../../../_constants/PostAdditionalTypes";
import * as SocialProviders from "../../../_constants/SocialProvider";
import SocialAccountPropType from "../../../_types//SocialAccount";
import PostPropType from "../../../_types/Post";
// import { formatPostMessage } from "../../../_utils/postMessageFormatter";
import { getFixedPhotosVideosOrder } from "../PostEditor/helpers";
import SocialAccountAvatar from "../SocialAccountAvatar/SocialAccountAvatar";
import { formatDuration } from "../../../_utils/common";

const SocialPostCardYouTube = ({ account, post, time, maxWidth, ...rest }) => {
  const type = account?.social_type;
  const [hover, setHover] = useState(false);

  const additionalFields = useMemo(() => {
    const additional = post?.additional || [];

    return additional.find(
      (item) =>
        item.source === SocialProviders.YOUTUBE &&
        item.type === PostAdditionalTypes.POST
    );
  }, [post]);

  const handleMouseEnter = useCallback(() => setHover(true), [setHover]);

  const handleMouseLeave = useCallback(() => setHover(false), [setHover]);

  if (!account || !post || !type) {
    return null;
  }

  const renderFooter = () => (
    <Flex alignItems="flex-start" sx={{ marginTop: "12px" }}>
      <Box sx={{ paddingRight: "12px" }}>
        <Box
          sx={{
            position: "relative",
            width: "36px",
            height: "36px",
            lineHeight: "36px",
          }}
        >
          <SocialAccountAvatar
            sx={{
              width: "full",
              height: "full",
              fontSize: "16px",
              borderRadius: "full",
            }}
            name={account.name}
            src={account.image}
            socialType={account.social_type}
          />
        </Box>
      </Box>
      <Box sx={{ paddingRight: "24px" }}>
        <Box
          sx={{
            fontSize: "14px",
            fontWeight: "700",
            lineHeight: "20px",
            marginBottom: "6px",
            color: "#030303",
          }}
        >
          <Text noOfLines="2" title={additionalFields?.title || ""}>
            {additionalFields?.title || ""}
          </Text>
        </Box>
        {/* {post?.message ? (
          <Box
            sx={{
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              "& a": {
                color: "#065fd4",
              },
              marginBottom: "6px",
              color: "#030303",
            }}
          >
            <Text
              noOfLines="4"
              title={post.message}
              dangerouslySetInnerHTML={{
                __html: formatPostMessage(post.message),
              }}
            />
          </Box>
        ) : null} */}
        <Box
          sx={{
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "18px",
            color: "#606060",
          }}
        >
          <Text isTruncated title={account.name}>
            {account.name}
          </Text>
        </Box>
        <Box
          sx={{
            fontSize: "12px",
            fontWeight: "400",
            lineHeight: "18px",
            color: "#606060",
          }}
        >
          {time}
        </Box>
      </Box>
    </Flex>
  );

  const renderMedia = () => {
    const maxItems = 1;
    const mediaItems = getFixedPhotosVideosOrder(
      post?.photos,
      post?.videos
    ).items;
    const mediaItemsSliced = mediaItems.slice(0, maxItems);

    const mediaItemStyles = {
      display: "inline-block",
      width: "100%",
      height: "100%",
      objectFit: "contain",
    };

    return (
      <Box>
        <Box
          onMouseEnter={handleMouseEnter}
          onMouseOver={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {mediaItemsSliced.map((item) => (
            <AspectRatio ratio={16 / 9} key={item.data.url}>
              <Box>
                {item.field === "videos" ? (
                  <Box
                    sx={{
                      position: "relative",
                      width: "full",
                      height: "full",
                    }}
                  >
                    <Box
                      as="video"
                      sx={mediaItemStyles}
                      src={item.data.url}
                      controls={hover}
                      preload="metadata"
                      poster={item.data.thumbUrl}
                    />
                    {hover ? null : (
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: "0",
                          right: "0",
                          margin: "4px",
                          padding: "3px 4px",
                          background: "rgba(0, 0, 0, 0.8)",
                          borderRadius: "2px",
                          color: "#ffffff",
                          fontWeight: "500",
                          fontSize: "12px",
                          lineHeight: "1em",
                        }}
                      >
                        {formatDuration(item.data?.meta?.duration)}
                      </Box>
                    )}
                  </Box>
                ) : (
                  <Image sx={mediaItemStyles} src={item.data.url} />
                )}
              </Box>
            </AspectRatio>
          ))}
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        background: "#f9f9f9",
        fontFamily: "Roboto, Arial, sans-serif",
        maxWidth: maxWidth,
      }}
      {...rest}
    >
      <Box sx={{ padding: "8px" }}>
        {renderMedia()}
        {renderFooter()}
      </Box>
    </Box>
  );
};

SocialPostCardYouTube.propTypes = {
  account: SocialAccountPropType.isRequired,
  post: PostPropType.isRequired,
  maxWidth: PropTypes.string,
  time: PropTypes.string.isRequired,
};

SocialPostCardYouTube.defaultProps = {
  maxWidth: "376px",
};

export default SocialPostCardYouTube;
